import { LOCALES } from '@marketplace/i18n';

export const transactionLogI18n = {
  [LOCALES.ENG]: {
    transaction_log_production: 'Production',
    //transaction_log_sandbox: 'Sandbox',
    transaction_log_timestamp: 'Timestamp',
    transaction_log_request: 'Request',
    transaction_log_status: 'Status',
    transaction_log_refresh: 'Refresh',
  },
};
